<script>
	import { base } from '$app/paths';

	export let title;
	export let description;
	export let path;
	export let image = '';
	export let type = 'website';
	export let robots = 'index, follow';

	const canonicalOrigin = 'https://tools.d-cine.net';
	$: canonicalPath = path.startsWith('/') ? path : `/${path}`;
	$: canonical = `${canonicalOrigin}${base}${canonicalPath}`;
	$: imageUrl = image
		? image.startsWith('http')
			? image
			: `${canonicalOrigin}${base}${image.startsWith('/') ? image : `/${image}`}`
		: '';
</script>

<svelte:head>
	<title>{title} | D-Cine.net cinema tools</title>
	<meta name="description" content={description} />
	<meta name="robots" content={robots} />
	<link rel="canonical" href={canonical} />
	<meta property="og:type" content={type} />
	<meta property="og:site_name" content="D-Cine.net Cinema Tools" />
	<meta property="og:title" content={title} />
	<meta property="og:description" content={description} />
	<meta property="og:url" content={canonical} />
	<meta name="twitter:card" content={imageUrl ? 'summary_large_image' : 'summary'} />
	<meta name="twitter:title" content={title} />
	<meta name="twitter:description" content={description} />
	{#if imageUrl}
		<meta property="og:image" content={imageUrl} />
		<meta name="twitter:image" content={imageUrl} />
	{/if}
</svelte:head>
